import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import CertificateCard from "../CertificateCard/CertificateCard";
import { Outlet } from "react-router-dom";

const TemplateLayout = () => {
  return (
    <>
      <Header />
      <main style={{ marginBottom: "80px" }}>
        <Outlet />
      </main>
       <CertificateCard />
      <Footer />
    </>
  );
};

export default TemplateLayout;